import React, {useCallback, useEffect, useRef, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import {addMember, editMember} from "../../api/RestCallHelper";
import DatePicker from "../../shared/DatePicker";
import FormHeader from "../../shared/FormHeader";
import Switch from "../../shared/Switch";
import TextInput from "../../shared/TextInput";
import {
  FormButton,
  FormButtonContainer,
} from "../../styles/globalStyles";
import {ROUTES} from "../../utils/RouteConstants";
import {validateForm} from "../../utils/ValidationUtil";
import {FeedbackReducerActionType, useFeedbackDispatch} from "../../utils/FeedbackContext";
import MemberFormDependantTable from "./MemberFormDependantTable";
import MemberFormNotesTable from "./MemberFormNotesTable";
import {
  FormSectionColumn, 
  FormSectionInputs, 
  FormSectionRow, 
  FormSectionTables,
  WideFormPage
} from "./MemberFormStyles"

export default () => {

  let history = useHistory();
  let location = useLocation();

  let dispatch = useFeedbackDispatch();

  const [formValidated, setFormValidated] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const isMounted = useRef(true);

  const [member, setMember] = useState({
    dob: null,
    doe: new Date(),
    paidJoiningFee: false,
    allowInvestmentOfFunds: false,
    donateBalanceToScheme: false,
  });

  useEffect(() => {
    if (location.state.edit) {
      console.log("member",location.state.member);
      setMember(location.state.member);
    }
  }, [location]);

  const sendRequest = useCallback(async () => {
    // don't send again while we are sending
    if (isSending) return;

    // update state
    setIsSending(true);

    // send the actual request
    if (location.state.edit) {
      editMember(member, location.state.member.id, dispatch, close, history, location);
    } else {
      addMember(member, dispatch, close, history, location);
    }

    // once the request is sent, update state again
    if (isMounted.current) {
      // only update if we are still mounted
      setIsSending(false);
    }
  }, [isSending, member, location, history]); // update the callback if the state changes


  const back = () => {
    if (location.state.last) {
      history.push(location.state.last, location.state.data);
    } else {
      history.push(ROUTES.MEMBERS);
    }
  };

  const close = (event, reason) => {
    console.log("In MemberForm close callback");
    if (reason === 'clickaway') return;

    dispatch({type: FeedbackReducerActionType.CLOSE_FEEDBACK});
    back();
  };

  useEffect(() => {
    setFormValidated(validateForm(member));
    console.log("member", member);
  }, [member, formValidated]);

  return (
  <>
      {console.log(member)}
    {console.log(location.state)}

  <WideFormPage>
  <FormSectionInputs>
          
    <FormHeader
      heading={location.state.edit ? "Edit Member" : "Add Member"}
    />
    
    <FormSectionRow>
      <TextInput
        label="First Name"
        value={member.name}
        onChange={(value) => setMember({ ...member, name:value })}
        style={{ margin: "10px", width: "50%" }}
      />

      <TextInput
        label="Last Name"
        value={member.surname}
        onChange={(value) => setMember({ ...member, surname:value })}
        style={{ margin: "10px", width: "50%" }}
      />
    </FormSectionRow>

    <FormSectionRow>

      <TextInput
        label="Address"
        value={member.address}
        onChange={(value) => setMember({ ...member, address:value })}
        style={{ margin: "10px", width: "50%" }}
      />

      <TextInput
        label="Cell Number"
        value={member.cellNumber}
        onChange={(value) => setMember({ ...member, cellNumber:value })}
        style={{ margin: "10px", width: "50%" }}
      />

    </FormSectionRow>

    <FormSectionRow>

      <TextInput
        label="Area"
        value={member.area}
        onChange={(value) => setMember({ ...member, area:value })}
        style={{ margin: "10px", width: "50%" }}
      />

      <TextInput
        label="Work Number"
        value={member.workNumber}
        onChange={(value) => setMember({ ...member, workNumber:value })}
        style={{ margin: "10px", width: "50%" }}
      />

    </FormSectionRow>

    <FormSectionRow>

      <TextInput
        label="Postal Code"
        value={member.postalCode}
        onChange={(value) => setMember({ ...member, postalCode:value })}
        style={{ margin: "10px", width: "50%" }}
      />

      <TextInput
        label="Home Number"
        value={member.homeNumber}
        onChange={(value) => setMember({ ...member, homeNumber:value })}
        style={{ margin: "10px", width: "50%" }}
      />

    </FormSectionRow>

    <FormSectionRow>

      <TextInput
        number
        label="ID Number"
        value={member.idNumber}
        onChange={(value) => setMember({ ...member, idNumber:value })}
        style={{ margin: "10px", width: "50%" }}
      />

      <TextInput
        label="Email  "
        value={member.email}
        onChange={(value) => setMember({ ...member, email:value })}
        style={{ margin: "10px", width: "50%" }}
      />
    </FormSectionRow>

    <FormSectionRow>

      <DatePicker
          label="DOE"
          value={member.doe}
          onChange={(value) => setMember({ ...member, doe: value }) }
          style={{ margin: "10px", width: "50%" }}
      />

      <FormSectionColumn>

        <Switch
            onChange = {(value) => setMember({...member, paidJoiningFee: value})}
            value = {member.paidJoiningFee}
            leftLabel = {<small> <b>Joining Fee</b></small>}
            rightLabel = {<small> Paid </small>}
        />

        <Switch
            onChange = {(value) => setMember({...member, allowInvestmentOfFunds: value})}
            value = {member.allowInvestmentOfFunds}
            leftLabel = {<small><b>Invest Funds</b></small>}
            rightLabel = {<small> Allow </small>}
        />

        <Switch
            onChange = {(value) => setMember({...member, donateBalanceToScheme: value})}
            value = {member.donateBalanceToScheme}
            leftLabel = {<small><b>Donate Balance</b></small>}
            rightLabel = {<small> Allow </small>}
        />
      </FormSectionColumn>
    </FormSectionRow>



  </FormSectionInputs>
  
    {location.state.edit === true &&

      <FormSectionTables>

        <MemberFormDependantTable member={member} />

        <MemberFormNotesTable member={member} />

      </FormSectionTables>

    }

  </WideFormPage>

  <FormButtonContainer>
      <FormButton
        disabled={isSending}
        onClick={sendRequest}
      >
        {location.state.edit ? "Edit Member" : "Add Member"}
      </FormButton>

      <FormButton
        onClick={back}
        disabled={isSending}
      >
        Cancel
      </FormButton>
  </FormButtonContainer>
  </>
  );
}
